module.exports = "/_next/static/images/TailoredProduct@2x-97c86b0516908632749c6d575fb8b975.webp";